import { SelectionType, Position } from "../../helpers/enum";
import { observable } from "mobx";

/**
* Selection defines model for selection object information
*
* @typedef Selection
* @type {Object}
* @property {id} BranchId identifier
* @property {title} Title of the Selection
* @property {odds} Odds of the Selection
* @property {Position} Position of the Selection
* @property {SelectionType} Selection type ML, HC, OU....
* @property {lineType} line type number
* @property {points} points type number
*/

export class Selection {
    id: string;
    title: string;
    @observable odds: number;
    position: Position;
    type: SelectionType;
    lineType: number;
    points: number;

    constructor(selectionData: Selection) {
        this.id = selectionData.id;
        this.title = selectionData.title;
        this.odds = selectionData.odds;
        this.position = selectionData.position;
        this.type = selectionData.type;
        this.lineType = selectionData.lineType;
        this.points = selectionData.points
    }
}